import { defineComponent as _defineComponent } from 'vue'
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import DeviceImage from '@/components/devices/DeviceImage.vue';
import { useI18n } from '@/composables/i18n';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { Device } from '@/models/device';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { DeviceVersion } from '@/services/metrics.service';
import { isEmpty, isNil } from '@/utils/misc';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceCard',
  props: {
    device: null
  },
  setup(__props: any) {

const props = __props as {
  device: Device;
};



const { t } = useI18n();

const fields: Array<keyof DeviceVersion> = [
  'EquipmentNumber',
  'ByVisionVersion',
  'ByMotionVersion',
  'CuttingHeadType',
  'SW_Version',
];

const deviceOverviewWidgetDefinition = computed<WidgetDefinition>(() =>
  new WidgetDefinition(
    WidgetEnum.CareOverviewDevice,
    props.device.deviceId,
    undefined,
    [],
  ).hideInfo(),
);

function getValue(
  data: DeviceVersion | null,
  property: keyof DeviceVersion,
): string | number {
  if (isEmpty(data)) {
    return t('no_data').toString();
  }
  if (isNil(data![property])) {
    return '-';
  }
  return data![property]!;
}

return { __sfc: true,props, t, fields, deviceOverviewWidgetDefinition, getValue, WidgetContainer, DeviceImage, isEmpty }
}

})